/* eslint key-spacing: 'off', comma-spacing: 'off', dot-notation: 'off' */
//import CtColumn from '@/bo/CtColumn';
import common from '@/scripts/common'

function formatStatistic(value, name) {
  switch (name) {
    case 'sampleSize':
    case 'weightedN':
      return common.formatNumber(value, 0);
    case 'rowPercentage':
    case 'columnPercentage':
    case 'totalPercentage':
      if (value === '*' || value === 'missing')
        return value;
      return common.formatNumber(value, 1) + '%';
    default:
      return name;
  }
}

function formatForXlsx(value, name) {
  switch (name) {
    case 'sampleSize':
    case 'weightedN':
      return value;
    case 'rowPercentage':
    case 'columnPercentage':
    case 'totalPercentage':
      if (value === '*' || value === 'missing')
        return value;
      return value + '%';
    default:
      return name;
  }
}

export default function CtReportCell (parms) {
    //id, rowLevel, columnData, statisticDefinition, totalSourceRecords, reportParms, isRowTotal
    this.apiName = parms.statisticDefinition.apiName;
    this.value = parms.columnData[this.apiName];
    this.sampleSize = common.parsePositiveInt(parms.columnData.sampleSize);
    this.id = parms.id ? parms.id : 0;
    this.title = parms.statisticDefinition.label;
    this.totalSourceRecords = parms.totalSourceRecords;
    this.isRowTotal = Boolean(parms.isRowTotal);
    this.rowClass = parms.rowLevel.rowLevel === 0 ? 'statistic-total' : 'statistic-cell';  //I don't think statistic-total is used anymore,
    this.statisticDefinition = parms.statisticDefinition;
    this.isMissing = this.value.isMissing;
    
    this.show = this.value !== undefined;

    if (this.apiName === 'sampleSize') {
      this.isSampleSizeIsTooLow = false;
      this.standardError = null;
      this.formattedCi = '';
      this.formattedSe = '';
      this.floatValue = this.sampleSize;
      this.noData = this.apiName === 'sampleSize' && parms.totalSourceRecords === 0;
      // this.relativeStandardError = null;
      this.isRelativeStandardErrorTooHigh = false;
    } else {
      this.isSampleSizeIsTooLow = this.value.isSampleTooSmall;
      this.isRelativeStandardErrorTooHigh = this.value.isRelativeStandardErrorTooHigh;
      this.floatValue = common.parseFloat(this.value.value);
      this.formattedCi = this.value.confidenceInterval === undefined ? '' : 
        formatCi(this.value.confidenceInterval, this.apiName);
      this.standardError = common.parseFloat(this.value.standardError);
      this.formattedSe = common.formatNumber(this.standardError, 
        this.apiName === 'weightedN' ? 0 : 1);

      this.noData = false;
      // this.relativeStandardError = this.standardError ? this.standardError / this.floatValue : null;
      // this.isRelativeStandardErrorTooHigh = this.relativeStandardError && this.relativeStandardError > 0.3;
      
      //  isSampleSizeIsTooLow ? 
      // : (this.isRelativeStandardErrorTooHigh ? 'Relative standard error of ' + common.formatNumber(this.relativeStandardError, 1) + 
      // ' is above the limit 0.3 and the ' 
      //   + this.title + ' of ' + this.floatValue + ' is not reliable' : '');
    }

    


    if (this.isSampleSizeIsTooLow || this.isRelativeStandardErrorTooHigh) {
      this.hideValues = true;
      this.hoverTitle = 'Estimate not available if the unweighted sample size for the denominator was < 50 or the Relative Standard Error (RSE) is > 0.3';
      this.ariaLabel = 'Sample size is too small';
      this.footnote = '*';
      this.suffix = '';
    } else if (this.noData) {
      this.hideValues = false;
      this.hoverTitle = 'No data available';
      this.ariaLabel = 'No data available';
      this.footnote = '**';
    } else if (this.isMissing) {
      this.hideValues = true;
      this.hoverTitle = 'Estimate could not be computed. Some estimates cannot be computed when the denominator sample size is 0, though other causes may exist as well.';
      this.ariaLabel = 'Estimate could not be computed';
      this.footnote = '-';
    } else {
      this.hideValues = false;
      this.hoverTitle = getHoverTitle(this)
      this.ariaLabel = this.title;
      this.footnote = '';
    }

    if (this.hideValues) {
      this.formattedValue = '';
      this.xlsxValue = '';
      this.formattedSe = '';
      this.formattedCi = '';
      this.standardError = '';
    } else {
      this.formattedValue = formatStatistic(this.floatValue, this.apiName);
      this.xlsxValue = formatForXlsx(this.floatValue, this.apiName);
    }
    // if (this.isRelativeStandardErrorTooHigh)
    //   return 'Relative standard error is above the limit 0.3 and the ' + this.title + ' is not reliable';
    // if (this.isSampleSizeIsTooLow)
    //   return 'Sample size is below 50 and ' + this.title + ' is not reliable';
    return '';
  }

  CtReportCell.prototype.isTheSameAs = function (other) {
    const isTheSameAs = this.apiName === other.apiName ||
      this.value === other.value ||
      this.sampleSize === other.sampleSize ||
      this.id === other.id ||
      this.title === other.title ||
      this.totalSourceRecords === other.totalSourceRecords ||
      this.isRowTotal === other.isRowTotal ||
      this.rowClass === other.rowClass ||
      this.statisticDefinition === other.statisticDefinition ||
      this.isSampleSizeIsTooLow === other.isSampleSizeIsTooLow ||
      this.isRelativeStandardErrorTooHigh === other.isRelativeStandardErrorTooHigh ||
      this.standardError === other.standardError ||
      this.floatValue === other.floatValue ||
      this.noData === other.noData ||
      // this.relativeStandardError === other.relativeStandardError ||
      this.hoverTitle === other.hoverTitle
      ;
    return isTheSameAs;
  };

  // function getA(apiName) {
  //     switch (apiName) {
  //       case 'sampleSize':
  //         return 'n';
  //       case 'rowPercentage':
  //         return 'Row%';
  //       case 'columnPercentage':
  //         return 'Col%';
  //       case 'totalPercentage':
  //         return '%';
  //       case 'weightedN':
  //         return 'Weighted N';
  //       default:`
  //         return statisticDefinition.apiName;
  //     }
  // }

  function getHoverTitle(cell) {
    if (cell.isSampleSizeIsTooLow || cell.isRelativeStandardErrorTooHigh)
      return 'Estimate not available if the unweighted sample size for the denominator was < 50 or the Relative Standard Error (RSE) is > 0.3'
    if (cell.noData)
      return 'No data available';
    if (cell.isMissing)
      return 'Estimate could not be computed. Some estimates cannot be computed when the denominator sample size is 0, though other causes may exist as well.';
    // if (cell.isRelativeStandardErrorTooHigh)
    //   return 'Relative standard error is above the limit 0.3 and the ' + cell.title + ' is not reliable';
    // if (cell.isSampleSizeIsTooLow)
    //   return 'Sample size is below 50 and ' + cell.title + ' is not reliable';
    return '';
  }

  function formatValue(value, apiName) {
    if (apiName === 'sampleSize' || apiName === 'weightedN')
      return common.formatNumber(value, 0);
    else
    return common.formatNumber(value, 1) + '%';
  }

  function formatCi(value, name) {
    if (name === 'weightedN')
      return common.formatNumber(value, 0);
    else
      return formatConfidenceInterval(value, 1);
  }

  function formatConfidenceInterval(value, decimalPlaces) {
    var range = common.getRange(value);
    if (range === null)
      return value;
    else
      return '(' + common.formatNumber(range[0], decimalPlaces) + ' - ' + common.formatNumber(range[1], decimalPlaces) + ')';
  }